import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useLocation } from "react-router-dom";

import TextField from "../../../ui/TextField";
import Button from "../../../ui/Button";

import {
  validateRequired,
  validateMaxlength,
} from "../../../../utils/validate";
import { MSG } from "../../../../utils/adminMessages";
import { useAuth } from "../../../../contexts/AuthContext";
import styles from "./Login.module.scss";
import { HTML_TITLE, ADMIN_LOGIN } from "../../../../utils/config";

// 管理者ログイン画面
const Login = () => {
  const { adminLogin, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  // 入力チェック用
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  // エラーメッセージ
  const [errorMsg, setErrorMsg] = useState("");

  // URLパラメータ
  let isSessionExp = false;
  const search = useLocation().search;
  const query = new URLSearchParams(search);
  if (query.get("sessionexp") == "1") {
    isSessionExp = true;
  }

  useEffect(
    function () {
      document.title = `${ADMIN_LOGIN.title} | ${HTML_TITLE}`;
      // 既にログイン済みの場合は/adminへ
      if (isAuthenticated) navigate("/admin", { replace: true });
    },
    [isAuthenticated, navigate]
  );

  // ログインボタン
  const onSubmit = async (data) => {
    // console.log(data);
    const result = await adminLogin(data);
    // console.log(json);
    if (!result) setErrorMsg(MSG.LOGIN_FAIL);
  };

  return (
    <section className={styles.login}>
      <form
        action=""
        className={styles.login__form}
        onSubmit={handleSubmit(onSubmit)}
      >
        <h3 className={styles.login__pagetitle}>
          シブカツ会員管理システムログイン
        </h3>
        {isSessionExp ? (
          <div className="">
            <p className={styles.login__session}>
              一定時間が経過したためログアウトしました。再度ログインしてください。
            </p>
          </div>
        ) : (
          <></>
        )}
        <TextField
          errors={errors}
          register={register}
          validation={{
            ...validateRequired(),
            ...validateMaxlength(10),
          }}
          label="ID"
          name="login_id"
          autocomplete="off"
        />
        <TextField
          type="password"
          errors={errors}
          register={register}
          validation={{
            ...validateRequired(),
            ...validateMaxlength(20),
          }}
          label="パスワード"
          name="password"
        />
        <p className={`help is-danger ${styles.field__msg}`}>{errorMsg}</p>

        <div className="field has-text-centered">
          <Button type="submit" styleType="login">
            ログイン
          </Button>
        </div>
      </form>
    </section>
  );
};
export default Login;
